<template>
    <AppNavigation>
        <mdb-container fluid>
            <textarea id="copy-text"/>
            <h1 class="h1-responsive">Orders 
                <mdb-btn color="primary" size="sm" @click="search"><i class="fas fa-sync"></i></mdb-btn>
                <mdb-tooltip v-if="is_sync" trigger="hover" :options="{placement: 'top'}">
                    <span slot="tip">Synchronized</span>
                    <a slot="reference" @click="syncAdminPN">
                        <mdb-btn color="success" size="sm"><mdb-icon icon="link" /></mdb-btn>
                    </a>
                </mdb-tooltip>
                <mdb-tooltip v-if="!is_sync" trigger="hover" :options="{placement: 'top'}">
                    <span slot="tip">Unsynchronized</span>
                    <a slot="reference" @click="syncAdminPN">
                        <mdb-btn color="danger" size="sm"><mdb-icon icon="unlink" /></mdb-btn>
                    </a>
                </mdb-tooltip>
            </h1>
            <mdb-row>
                <mdb-col offset="2" col="2" class="d-flex flex-column align-items-center lime accent-1 py-3 rounded">
                    <div>{{count_pending_rider}}</div>
                    <div>Pending</div>
                </mdb-col>
                <mdb-col offset="1" col="2" class="d-flex flex-column align-items-center blue accent-1 py-3 rounded">
                    <div>{{count_collection_rider}}</div>
                    <div>Collecting</div>
                </mdb-col>
                <mdb-col offset="1" col="2" class="d-flex flex-column align-items-center green accent-1 py-3 rounded">    
                    <div>{{count_delivering_rider}}</div>
                    <div>Delivering</div>
                </mdb-col>
            </mdb-row>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <input v-on:keyup.enter="search" v-model="order_number" type="text" placeholder="#Order Number" class="form-control">
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <select v-model="status" class="browser-default custom-select">
                        <option value="" selected>Status</option>
                        <option value="NEW">New</option>
                        <option value="COMPLETED">Completed</option>
                        <option value="CANCELLED">Cancelled</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <select v-model="payment_type" class="browser-default custom-select">
                        <option value="" selected>All Payment Method</option>
                        <option value="CASH">Cash</option>
                        <option value="ONLINE_BANKING">Online Banking</option>
                        <option value="EWALLET">E-wallet</option>
                        <option value="CREDIT_DEBIT_CARD">Card</option>
                        <option value="EWALLET_TNG">EGHL TnG</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <multiselect
                    v-model="zone_selected"
                    :multiple="true"
                    :close-on-select="false"
                    placeholder="Zones"
                    label="name"
                    track-by="name"
                    :options="zones">
                    </multiselect>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col md="3">
                    <select search v-model="merchant_select" class="browser-default custom-select">
                        <option value="">All Merchants</option>
                        <option :value="merchant.id" v-bind:key="merchant.id" v-for="merchant in merchants">{{merchant.name}}</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <select v-model="rider_select" class="browser-default custom-select">
                        <option value="">All Rider</option>
                        <option v-for="partner in partners" v-bind:key="partner.id" :value="partner.id">[ {{partner.partner_profile.partner_code}} ] - {{partner.partner_profile.fullname}}</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <select v-model="service_id" class="browser-default custom-select">
                        <option value="0">All Services</option>
                        <option value="1">Food Delivery</option>
                        <option value="2">Virtual Merchant Delivery</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <input v-on:keyup.enter="search" v-model="phone_number" type="text" placeholder="#Phone Number" class="form-control">
                </mdb-col>
            </mdb-row>
            <p class="text-danger" v-if="loading">Please Wait... Fetching Data dont panic don't spam refresh!</p>
            <mdb-tbl responsive hover>
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th width="11%">Order No.</th>
                    <th width="16%">Merchant</th>
                    <th width="16%">Customer</th>
                    <th width="19%">Rider</th>
                    <th width="10%">Status</th>
                    <th width="10%">Bill Charge</th>
                    <th width="13%" class="text-right">Date Time</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr v-for="(order, index) in orders" :key="order.id"  @click="showOrderDetail(order.id, index)" style="cursor: pointer">
                    <th scope="row">{{index+1}}</th>
                    <td>
                        <div @click.prevent.stop>{{order.order_number}} <mdb-icon class="order-number-text" @click.native="copyClipboardOrderNumber(order.order_number)" icon="paste" /></div>
                        <div v-if="order.service_id==1 && order.merchant.zone" :style="{'color': order.merchant.zone.color}">{{order.merchant.zone.name}}</div>
                        <div v-if="order.service_id==1" class="small">Food Delivery</div>
                        <div v-if="order.service_id==2" class="small">Virtual Merchant</div>
                        <div class="d-flex flex-row">
                            <div v-if="order.service_id==1 && order.merchant.is_pb==1" class="pb-remark small">PB</div>
                            <div v-if="order.service_id==1 && order.merchant.is_mart==1" class="mart-remark small">Mart</div>
                            <div v-if="order.comment_admin" class="note-remark small">Note</div>
                        </div>
                        <div @click.prevent.stop><mdb-icon class="order-number-text" @click.native="openDirectionMap(order.pickup, order.deliver)" far icon="map" /> Route</div>
                    </td>
                    <td>
                        <div @click.prevent.stop v-if="order.service_id==1">{{order.merchant.name}} <mdb-icon class="order-number-text" @click.native="navigateToMerchantList(order.merchant.name)" icon="link" /></div>
                        <div v-if="order.service_id==1">{{order.merchant.contact_number}}</div>
                        <div v-if="order.service_id==1">{{order.pickup.address}}</div>
                        <div v-if="order.service_id==2">{{order.virtual_merchant.name_en}}</div>
                    </td>
                    <td>
                        <div @click.prevent.stop>{{order.customer_user.name}} <mdb-icon class="order-number-text" @click.native="navigateToUser(order.customer_user.phone_number)" icon="link" /></div>
                        <div>{{order.customer_user.phone_number}}</div>
                        <div>{{order.deliver.address}}</div>
                    </td>
                    <td>
                        <div v-if="order.job && order.job.partner_user_id!=null && order.partner_user_id==null" class="text-warning">[ {{order.job.partner_user.partner_profile.partner_code}} ] - {{order.job.partner_user.partner_profile.fullname}}</div>
                        <div v-if="order.partner_user_id" class="text-success">[ {{order.partner_user.partner_profile.partner_code}} ] - {{order.partner_user.partner_profile.fullname}}</div>
                        <select  v-on:click.stop v-if="checkAllowToSwitchPartner(order)" class="browser-default custom-select" @change="assignRider(order)" v-model="order.job.partner_user_id">
                            <option :value="0">None</option>
                            <option v-for="partner in partners" v-bind:key="partner.id" :value="partner.id">[ {{partner.partner_profile.partner_code}} ] - {{partner.partner_profile.fullname}}</option>
                        </select>
                    </td>
                    <td>
                        <div v-if="order.status=='CANCELLED'" class="status-cancelled">{{order.status}}</div>
                        <div v-if="order.status=='NEW'" class="status-new">{{order.status}}</div>
                        <div v-if="order.status=='COMPLETED'" class="status-completed">{{order.status}}</div>
                        <div class="text-center">{{order.current_step}}</div>
                        <div class="text-center">{{order.cancel_reason}}</div>
                        <div class="text-center">{{momentFormat(order.time_cancel_job)}}</div>
                        <div class="text-center" v-if="order.service_order_dispute.length!=0">
                            <mdb-badge color="warning">Dispute: {{order.service_order_dispute.length}}</mdb-badge>
                        </div>
                    </td>
                    <td class="d-flex flex-column">
                        <div style="text-decoration: line-through;" v-if="order.service_charge.subtotal != order.service_charge.grand_total">RM {{order.service_charge.subtotal}}</div>
                        <div class="d-flex flex-row">
                            <mdb-tooltip v-if="order.service_charge.payment_type=='EWALLET_TNG'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">EGHL TnG</span>
                                <a slot="reference">
                                <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='ONLINE_BANKING'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Online Banking</span>
                                <a slot="reference">
                                <img :src="require('@/assets/online_banking.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='CASH'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Cash</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/cash.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='CREDIT_DEBIT_CARD'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Card</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/card.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='EWALLET'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">E-Wallet</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/e_wallet.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <mdb-tooltip v-if="order.service_charge.payment_type=='TNG'" trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Touch and Go eWallet</span>
                                <a slot="reference">
                                    <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                </a>
                            </mdb-tooltip>
                            <div class="ml-2">RM {{order.service_charge.grand_total}}</div>
                        </div>
                    </td>
                    <td class="text-right">
                        <div>{{momentFormat16(order.created_at)}}</div>
                        <div class="text-success">{{momentFormat(order.time_complete)}}</div>
                        <div class="text-danger">{{momentFormat(order.time_cancel_job)}}</div>
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <OrderDetailComponent :promo_codes="promo_codes" :id="focus_order_id" :visible="order_detail_component" :close="closeOrderDetailComponent" :callback="callback" />
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbRow, mdbCol, 
mdbTooltip, mdbBtn, mdbIcon, mdbBadge
  } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import scroll from '../js/infinityScroll';
import moment from 'moment';
import OrderDetailComponent from '../components/OrderDetailComponent';
import {checkPermissionsBinary} from '../js/helper';
// import {APP_FILE_URL} from '../js/config';
import Multiselect from 'vue-multiselect'

export default {
  name: 'orders',
  components: {
    mdbContainer,
    AppNavigation, mdbTooltip,
    mdbTbl, mdbTblHead, mdbTblBody,
    mdbRow, mdbCol, mdbBtn, mdbBadge,
    OrderDetailComponent, mdbIcon,
    Multiselect
  },
  data: ()=>({
    orders:[],
    order_number: "",
    order_detail_component: false,
    focus_order_id: 0,
    focus_index: 0,
    loading: false,
    status: "",
    payment_type: "",
    refund: 0,
    partners: [],
    merchant_select: "",
    users: [],
    user_list: [],
    customer_user_id: "",
    merchants: [],
    timer: null,
    promo_codes: [],
    service_id: 0,
    phone_number: "",
    zone_selected: [],
    zones: [],
    rider_select: "",
    is_sync: false,
    count_pending_rider: 0,
    count_collection_rider: 0,
    count_delivering_rider: 0
  }),
  methods: {
    getData(){
        if(this.loading){
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/get_orders",
            data: {
                id: this.orders.length==0?null:this.orders[this.orders.length-1].id,
                order_number: this.order_number,
                status: this.status,
                payment_type: this.payment_type,
                refund:this.refund,
                merchant_select: this.merchant_select,
                phone_number: this.phone_number,
                service_id: this.service_id,
                zones: this.zone_selected,
                partner_id: this.rider_select
            },
            complete: ()=>this.loading=false,
            success: result=>{
                let _temp=[...this.orders];
                this.orders=_temp.concat(result.data.orders);
                this.count_delivering_rider=result.data.count_delivering_rider;
                this.count_collection_rider=result.data.count_collection_rider;
                this.count_pending_rider=result.data.count_pending_rider;
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    getRiderData(){
        ajax({
            url: "admin/get_partner_list",
            success: result=>{
                this.partners=result.data;
                this.partners.sort((a, b)=>{
                    if(a.partner_profile.partner_code < b.partner_profile.partner_code) { return -1; }
                    if(a.partner_profile.partner_code > b.partner_profile.partner_code) { return 1; }
                    return 0;
                })
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    search(){
        this.orders=[];
        this.getData();
    },
    momentFormat16(date){
        if(date){
            return moment(date, "YYYY-MM-DD h:mm:ss").utcOffset('+16:00').format('DD/MM/YYYY h:mm a');
        }
        return "";
    },
    momentFormat(date){
        if(date){
            return moment(date, "YYYY-MM-DD h:mm:ss").format('DD/MM/YYYY h:mm a');
        }
        return "";
    },
    showOrderDetail(id, index){
        this.focus_order_id=id;
        this.focus_index=index;
        this.order_detail_component=true;
    },
    closeOrderDetailComponent(){
        this.order_detail_component=false;
        this.focus_order_id=0;
        this.focus_index=0;
    },
    assignRider(order){
        ajax({
            url: "admin/assign_job_rider",
            data: {service_order_id: order.id, partner_user_id: order.job.partner_user_id},
            success: ()=>{
                if(order.job.partner_user_id==0){
                    order.job.partner_user_id=null;
                    order.partner_user_id=null;
                }
                this.$notify.success({message: "Partner Assigned", position: 'top right', timeOut: 5000});
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    permissionCheck(permission){
        return checkPermissionsBinary(permission, this.$store.state.permissions);
    },
    checkAllowToSwitchPartner(order){
        if(order.current_step=="PENDING_PAYMENT" || order.current_step=="NEW"){
            return false;
        }
        if(order.job && order.status=='NEW' && this.permissionCheck(9)){
            return true;
        }
        return false;
    },
    callback(service_order=null){
        if(service_order==null){
            this.search();
        }else{
            let orders = [...this.orders];
            orders[this.focus_index]=service_order;
            this.orders=orders;
        }
    },
    requestSearch(value){
        clearTimeout(this.timer);
        this.users=[];
        this.user_list=[];
        if(value==""){
            return false;
        }
        this.timer=setTimeout(()=>{
            ajax({
                url: "admin/list_filter_users",
                data: {search: value},
                success: result=>{
                    result.data.forEach(user => {
                        this.user_list.push(user.name)
                    });
                    this.users=result.data;
                },
                fail: ()=>{
                    this.users=[];
                    this.user_list=[];
                },
            })
        }, 800);
    },
    filterName(item, search){
        if(item.toLowerCase().indexOf(search.toLowerCase()) > -1){
            console.log('test');
        }
    },
    copyClipboardOrderNumber(order_number){
        let textArea = document.querySelector('#copy-text')
        textArea.value=order_number;
        textArea.select();
        document.execCommand('copy');
        this.$notify.success({message: "Order Number Copied", position: 'top right', timeOut: 5000});
    },
    navigateToMerchantList(name){
        if(checkPermissionsBinary(20, this.$store.state.permissions)){
            // sessionStorage.setItem('merchant_list', name);
            this.$router.push({ name: 'merchant_list', params: {name: name}});
        }
    },
    navigateToUser(phone){
        if(checkPermissionsBinary(3, this.$store.state.permissions)){
            this.$router.push({ name: 'users', params: {phone: phone}});
        }
    },
    openDirectionMap(pickup, destination){
        let url=`https://www.google.com/maps/dir/?api=1&origin=${pickup.lat},${pickup.lng}&destination=${destination.lat},${destination.lng}`;
        window.open(url);
    },
    filterResults(item, search){
        return item.toLowerCase().indexOf(search.toLowerCase()) === 0;
    },
    handleMerchantSearch(merchant){
        console.log(merchant);
    },
    syncAdminPN(){
        ajax({
            url: "admin/toggle_pn_admin",
            success: result=>{
                this.is_sync=result.data;
                if(result.data){
                    this.$notify.success({message: "Connection Linked", position: 'top right', timeOut: 5000})
                }else{
                    this.$notify.error({message: "Connection Unlink", position: 'top right', timeOut: 5000})
                }
            },
            fail: ()=>{
                this.$notify.warning({message: 'Failed to Sync', position: 'top right', timeOut: 5000})
            },
        })
    }
  },
  mounted: function(){
        // if(this.$messaging){
        //     this.$messaging.onMessage(payload=>{
        //         // Customize notification here
        //         const notificationTitle = payload.data.title;
        //         const notificationOptions = {
        //             body: payload.data.body,
        //             icon: "./logo.png",
        //         };
        //         new Notification(notificationTitle, notificationOptions)
        //     })
        // }      
        let temp=sessionStorage.getItem('order_number', '');
        sessionStorage.removeItem('order_number');  
        if(temp){
            this.order_number=temp;
        }
        this.getData();
        this.getRiderData();
        scroll(()=>this.getData());
        ajax({
            url: "admin/get_compensate_voucher",
            success: result=>{
                this.promo_codes=result.data;
            }
        })
        ajax({
            url: "admin/list_all_merchants",
            success: result=>{
                this.merchants=result.data;
            },
        })
        ajax({
            url: "admin/get_zones",
            success: result=>{
                this.zones=result.data.admin_zones;
            },
        })
        ajax({
            url: "admin/get_pn_admin",
            success: result=>{
                this.is_sync=result.data;
            },
        })
  },
  watch: {
      status(){
        this.search();
      },
      payment_type(){
        this.search();
      },
      merchant_select(){
          this.search();
      },
      refund(){
        if(this.refund==0){
            this.status="";
            this.search();
        }else{
            this.status="CANCELLED";
            this.search();
        }
      },
      service_id(){
          this.search();
      },
      zone_selected(){
          this.search();
      },
      rider_select(){
          this.search();
      }
  }
}
</script>

<style scoped>
.status-cancelled{
    border: 1.5px solid #ff4444;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff4444;
}
.status-completed{
    border: 1.5px solid #00C851;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00C851;
}
.status-new{
    border: 1.5px solid #4285F4;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4285F4;
}
#copy-text{
    position: absolute;
    top: -9999999999px;
    left: -9999999999px;
}
.order-number-text:hover{
    color: #4285F4;
    font-weight: bold;
}
.order-number-text{
    font-weight: bold;
}
.pb-remark{
    background-color: #E91E63;
    color: #fff;
    width: 30px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 10px;
    margin: 0px 5px 0px 00px;
}
.mart-remark{
    background-color: #4caf50;
    color: #fff;
    width: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 30px;
    margin: 0px 5px 0px 00px;
}
.note-remark{
    background-color: #ffeb3b;
    color: #000;
    width: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 30px;
    margin: 0px 5px 0px 00px;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>